module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_c('router-link', {
    attrs: {
      "to": {
        name: 'userDetails',
        params: {
          userUid: _vm.registration.user.uid
        }
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.formatUserWithTag(_vm.registration.user)) + "\n    ")])], 1), _vm._v(" "), ((_vm.isMissionEditor || _vm.hasMissionSlotlistCommunityPermission) && _vm.registration.uid) ? _c('td', {
    domProps: {
      "innerHTML": _vm._s(_vm.formattedComment)
    }
  }) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDateTime(_vm.registration.createdAt)))]), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    domProps: {
      "innerHTML": _vm._s(_vm.formattedConfirmation)
    }
  }), _vm._v(" "), ((_vm.isMissionEditor || _vm.hasMissionSlotlistCommunityPermission) && _vm.registration.uid && !_vm.hasMissionEnded) ? _c('td', {
    staticClass: "text-center"
  }, [(!_vm.registration.confirmed) ? _c('b-btn', {
    attrs: {
      "variant": "success",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.modifyMissionSlotRegistration(true)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.registration.confirmed) ? _c('b-btn', {
    attrs: {
      "variant": "warning",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.modifyMissionSlotRegistration(false)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isMissionEditor) ? _c('b-btn', {
    attrs: {
      "variant": "danger",
      "size": "sm"
    },
    on: {
      "click": _vm.deleteMissionSlotRegistration
    }
  }, [_c('i', {
    staticClass: "fa fa-trash",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e()], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a3c6846"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/missions/MissionSlotRegistrationsRow.vue
// module id = 529
// module chunks = 0